<template lang="pug">
label.suus__counter__label(for="guests") {{labelText}}
  v-text-field.suus__counter(
    :disabled="disabled"
    filled,
    rounded,
    v-model="guests",
    :rules="[rules.required, rules.guests]"
  )
    v-btn.mt-0(
      elevation="0",
      fab,
      color="primary",
      slot="prepend-inner",
      @click="subtract"
      :disabled="disabled"
    )
      v-icon {{ minusIcon }}
    v-btn.mt-0(
      elevation="0",
      fab,
      color="primary",
      slot="append",
      @click="add"
      :disabled="disabled"
    )
      v-icon {{ plusIcon }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mdiMinus, mdiPlus } from "@mdi/js"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  props: {
    value: {
      type: Number,
      default: 0,
    },
    disabled:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    labelText(): string {
      return this.t("label")
    },
    rules(): object {
      return {
        required: (value) => {
          if (value === 0 || !!value) {
            return true
          }
          return this.tRules("rule1")
        },
        guests: (value) => {
          if (value > 20) {
            return this.tRules("rule2")
          }
          return (
            this.validationPattern.test(value) ||
            this.tRules("rule3")
          )
        },
      }
    },
    guests: {
      get(): number {
        return this.value ?? 0
      },
      set(value: number) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    add(): void {
      this.guests++
    },
    subtract(): void {
      if (this.guests > 0) {
        this.guests--
      }
    },
  },
  setup() {
    const minusIcon = mdiMinus
    const plusIcon = mdiPlus

    const { t, getComponent } = useTranslate("components.guest_modal")
    const { t:tRules } = getComponent("rules")

    return {
      minusIcon,
      plusIcon,
      validationPattern: /^[0-9]{1,2}$/,
      t,
      tRules
    }
  },
})
</script>
